/** Configuracion leida de las variables de entorno de Vite */
export const environment = {
  CLIENT_ID: import.meta.env.VITE_CLIENT_ID ?? "",
  AUTHORITY: import.meta.env.VITE_AUTHORITY ?? "",
  REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
  POST_LOGOUT_REDIRECT_URI:
    import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI ?? window.location.origin,
  API_URL: import.meta.env.VITE_API_URL ?? "",
};
